import React from 'react'

import CompanyServiceToggleButton from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/nonFcaServices/CompanyServiceToggleButton'
import { Heading } from '@/components/ui/heading'
import {
  useCurrentCompanyServicesQuery,
  useInvalidateCurrentCompanyServicesQuery,
} from '@/hooks/useCompanyServicesQuery'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { AvailableServiceAreaCollectionItem } from '@/types/responses/companies'

interface Props {
  results: AvailableServiceAreaCollectionItem[]
  headingText: string
  searchTerm: string
  onUpdate?: () => void
}

const ResultsSection: React.FC<Props> = ({
  results,
  headingText,
  searchTerm,
  onUpdate,
}) => {
  const currentCompany = useCurrentCompanyOrFail()
  const invalidateCompanyServicesQuery =
    useInvalidateCurrentCompanyServicesQuery()

  const companyServicesQuery = useCurrentCompanyServicesQuery()
  const companyServices = companyServicesQuery.data?.['hydra:member']

  if (results.length === 0) {
    return null
  }

  function getServiceIdByServiceAreaId(
    serviceAreaId: number,
  ): number | undefined {
    if (!companyServices) {
      return
    }

    return companyServices.find(
      (companyService) => companyService.serviceArea.id === serviceAreaId,
    )?.id
  }

  return (
    <div className="w-full">
      <Heading size={4} as="h2" className="my-4">
        {headingText}
      </Heading>

      <div className="flex flex-col flex-wrap gap-3 md:flex-row">
        {results.map((serviceArea: AvailableServiceAreaCollectionItem) => (
          <CompanyServiceToggleButton
            key={serviceArea.id}
            companyId={currentCompany.id}
            serviceId={getServiceIdByServiceAreaId(serviceArea.id)}
            serviceAreaId={serviceArea.id}
            serviceAreaName={serviceArea.name}
            onChangeSaved={() => {
              invalidateCompanyServicesQuery()

              if (onUpdate) {
                onUpdate()
              }
            }}
            searchTerm={searchTerm}
          />
        ))}
      </div>
    </div>
  )
}

export default ResultsSection
